import { useQuery } from "react-query";
import { getAllTasks } from "@/features/task/services/taskService";
const useParentTasks = () => {
    const { data, error, isLoading } = useQuery(["parentTasks"], () => getAllTasks({}), {
        staleTime: 60000,
    });
    return {
        tasks: data?.tasks || [],
        loading: isLoading,
        error: error ? error.message : null,
    };
};
export default useParentTasks;
